import { render, staticRenderFns } from "./BlockedPage.vue?vue&type=template&id=5a778d34&"
import script from "./BlockedPage.vue?vue&type=script&lang=js&"
export * from "./BlockedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports